export default __webpack_public_path__ + "static/media/icon_sub-section.f383eabc.svg";